import { d as defaultFormatters, c as createFormat, e as extend, a as createCustomFormatFn, b as createParse, p as parseOrThrowWrapper, f as defaultParsers } from '../../default-parsers-65188e32.js';
export { k as addDate, j as addHours, g as addMilliseconds, i as addMinutes, l as addMonth, h as addSeconds, m as addYear, T as asValidDateOrNull, E as diffCalendarDate, D as diffCalendarMonth, C as diffCalendarYear, z as diffDate, y as diffHours, v as diffMilliseconds, x as diffMinutes, A as diffMonth, I as diffPreciseDate, H as diffPreciseHours, G as diffPreciseMinutes, J as diffPreciseMonth, F as diffPreciseSeconds, K as diffPreciseYear, w as diffSeconds, B as diffYear, L as formatDateIso, M as formatDateTimeIso, N as formatLocalIso, R as fromDate, S as fromDateOrThrow, Q as isValidDate, U as newValidDate, V as newValidDateOrThrow, O as parseIso, P as parseIsoOrThrow, q as resetDate, s as resetHours, o as resetISOWeek, t as resetMinutes, n as resetMonth, u as resetSeconds, r as resetYear } from '../../default-parsers-65188e32.js'; // http://new.gramota.ru/spravka/buro/search-answer?s=242637

var monthsShort = ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'];
var monthsFull = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'];
var monthsGenitive = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
var weekdays2char = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
var weekdays3char = ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'];
var weekdaysFull = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
var meridiem = ['ночи', 'утра', 'дня', 'вечера'];

function timeOfDay(date) {
  var hours = date.getHours();

  if (hours >= 17) {
    return meridiem[3];
  } else if (hours >= 12) {
    return meridiem[2];
  } else if (hours >= 4) {
    return meridiem[1];
  } else {
    return meridiem[0];
  }
}

var formatters = {
  // Month: янв., фев., ..., дек.
  MMM: function (date) {
    return monthsShort[date.getMonth()];
  },
  // Month: январь, февраль, ..., декабрь
  MMMM: function (date, index, tokens) {
    var month = date.getMonth();
    if (tokens === undefined || index === undefined || index < 2) return monthsFull[month];
    var prevToken = tokens[index - 2];

    if (typeof tokens[index - 1] === 'string' && prevToken === defaultFormatters.D || prevToken === defaultFormatters.DD) {
      // Generate formatters like 'D[some string]MMMM',
      // where month is in the genitive case: января, февраля, ..., декабря
      return monthsGenitive[month];
    }

    return monthsFull[month];
  },
  // Day of week: вс, пн, ..., сб
  dd: function (date) {
    return weekdays2char[date.getDay()];
  },
  // Day of week: вск, пнд, ..., суб
  ddd: function (date) {
    return weekdays3char[date.getDay()];
  },
  // Day of week: воскресенье, понедельник, ..., суббота
  dddd: function (date) {
    return weekdaysFull[date.getDay()];
  },
  // Time of day: ночи, утра, дня, вечера
  A: timeOfDay,
  a: timeOfDay,
  aa: timeOfDay,
  // Generate ordinal version of formatters: M -> Mo, DDD -> DDDo, etc.
  Do: function (date) {
    return defaultFormatters['D'](date) + '-е';
  },
  Wo: function (date) {
    return defaultFormatters['W'](date) + '-й';
  },
  Mo: function (date) {
    return defaultFormatters['M'](date) + '-й';
  },
  DDDo: function (date) {
    return defaultFormatters['DDD'](date) + '-й';
  },
  do: function (date) {
    return defaultFormatters['d'](date) + '-й';
  },
  Qo: function (date) {
    return defaultFormatters['Q'](date) + '-й';
  },
  'Do MMMM': function (date) {
    return formatters['Do'](date) + ' ' + monthsGenitive[date.getMonth()];
  }
};
var parsers = {
  // Month: янв., фев., ..., дек.
  MMM: [monthsShort.join('|'), function (date, value) {
    var index = monthsShort.indexOf(value.toLowerCase());
    date.setMonth(index);
  }],
  // Month: январь, февраль, ..., декабрь
  // ... января, февраля, ..., декабря
  MMMM: [monthsFull.concat(monthsGenitive).join('|'), function (date, value) {
    value = value.toLowerCase();
    var index = monthsFull.indexOf(value);
    if (index < 0) index = monthsGenitive.indexOf(value);
    date.setMonth(index);
  }],
  // Generate ordinal version of parsers by cutting the suffix
  Do: ordinalParser('D', '-е'),
  Wo: ordinalParser('W', '-й'),
  Mo: ordinalParser('M', '-й'),
  DDDo: ordinalParser('DDD', '-й'),
  do: ordinalParser('d', '-й'),
  Qo: ordinalParser('Q', '-й')
};

function ordinalParser(token, suffix) {
  return ['\\d+' + suffix, function (date, value) {
    defaultParsers[token][1](date, value.slice(0, -suffix.length));
  }];
}

var format = createFormat(extend(defaultFormatters, formatters));
var createCustomFormat = createCustomFormatFn(extend(defaultFormatters, formatters));
var parse = createParse(extend(defaultParsers, parsers));
var parseOrThrow = parseOrThrowWrapper(parse);
export { createCustomFormat, format, formatters, parse, parseOrThrow };